import {useEffect, useState} from 'react'
import {subscribe, unsubscribe} from '@/script/event.mjs'

const getTreeData = (map) => {
    const walk = (node) => {
        const text = map.getNodeText(node)
        const prefix = map.getNodeTextPrefix(node)
        const suffix = map.getNodeTextSuffix(node)
        const title = [prefix, text, suffix].join('') || '(空白)'

        const children = [...map.children(node)].filter(
            n => ! map.isNodeHidden(n)
        )

        const {id} = node

        return {
            children: children.map(walk),
            id,
            data: {id, title},
        }
    }

    return [walk(map.root)]
}

export default map => {
    const [treeData, setTreeData] = useState(() => getTreeData(map))

    useEffect(
        () => {
            const handleModelChange = () => {
                map.logger.withOff(
                    () => setTreeData(getTreeData(map))
                )
            }

            subscribe(map, 'model_change', handleModelChange)

            return () => {
                unsubscribe(map, 'model_change', handleModelChange)
            }
        },

        []
    )

    return treeData
}
